import { Routes, Route } from "react-router";
import { Navigate } from "react-router-dom";
import { HasPermission } from "Core/security";
import { useSelector } from "react-redux";

//Views
import MaintenanceWarnings from "./views/maintenanceWarnings";
import CameraLogs from "./views/cameraLogs";
import DmsStatuses from "./views/dmsStatuses";
import PowerLogs from "./views/powerLost";
import SdCardStatus from "./views/sdCardStatus";
import WhiteListedDevices from "./views/whiteListedDevices";
import FirmwaresReview from "./views/firmwaresReview"

const VidfleetView = (props) => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <>
            <Routes>
                {HasPermission(user, "vdfltfw") && <Route path="firmwaresreview" element={<FirmwaresReview />} />}
                {HasPermission(user, "manw") && <Route path="maintenancewarnings" element={<MaintenanceWarnings />} />}
                {HasPermission(user, "camlog") && <Route path="cameralogs" element={<CameraLogs />} />}
                {HasPermission(user, "dmst") && <Route path="dmsstatuses" element={<DmsStatuses />} />}
                {HasPermission(user, "pwlst") && <Route path="powerlost" element={<PowerLogs />} />}
                {HasPermission(user, "sdcards") && <Route path="sdcardstatus" element={<SdCardStatus />} />}
                {HasPermission(user, "wlstd") && <Route path="whitelisteddevices" element={<WhiteListedDevices />} />}
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default VidfleetView;
